import { ALERT_VIEWED } from 'src/app/shared/dataAnalytics/schema/constants';
import { callbackOnDifference } from 'src/app/utils/callbackOnDifference';
import type { TrackingFnProps } from 'src/app/utils/validation';
import getTrackingAdapter from 'src/app/v1/dataAnalytics';

const ruleName = 'notEmail';

export const sendPerUnitBillingValidationTrackingEvents = ({
  validationResult,
  fieldName,
}: TrackingFnProps) => {
  const { errors } = validationResult;
  const error = errors.find(
    ({ rule, fieldName: errorFieldName }) =>
      errorFieldName === fieldName && rule === ruleName,
  );

  // Only send tracking event when error message changes
  // not if they stay the same....
  callbackOnDifference({
    callback: () => {
      if (!error) return;

      getTrackingAdapter.sendLinkEvent({
        alertShown: [
          {
            type: 'banner',
            position: 'content',
            tone: 'critical',
            messageCode: 'remove inappropriate contact details',
            message: 'Emails arent allowed in your job ad.',
          },
        ],
        eventName: ALERT_VIEWED,
        fieldName,
      });
    },
    data: error?.message,
    fieldName,
    ruleName,
  });
};
